import Glide from "@glidejs/glide";

(function () {
    "use strict";

    const glideArray = document.querySelectorAll(".glide");
    glideArray.forEach((glide) => {
        const perView = glide.getAttribute("data-perview")
            ? glide.getAttribute("data-perview")
            : 3;
        const autoPlay = glide.getAttribute("data-autoplay")
            ? glide.getAttribute("data-autoplay") == "0"
                ? false
                : glide.getAttribute("data-autoplay")
            : 3000;
        new Glide(glide, {
            type: "carousel",
            gap: 20,
            startAt: 0,
            perView: perView,
            autoplay: autoPlay,
            breakpoints: {
                768: {
                    perView: 1,
                    peek: { before: 0, after: 250 },
                },
                428: {
                    perView: 1,
                    peek: { before: 0, after: 130 },
                },
            },
        }).mount();
    });
})();
